// DogGoods Product Page Enhancements
// This file provides additional functionality for the enhanced product page

(function($) {
    'use strict';
    
    $(document).ready(function() {
        
        // Initialize product page enhancements
        initializeProductEnhancements();
        
        function initializeProductEnhancements() {
            // Additional product page functionality can be added here
            console.log('DogGoods product page enhancements loaded');
            
            // Example: Handle product page analytics
            trackProductView();
            
            // Example: Initialize any product-specific features
            initializeProductFeatures();
            
            // Initialize review stars click functionality
            initializeReviewStarsClick();
        }
        
        function trackProductView() {
            // Add product view tracking if needed
            if (typeof VastaShop !== 'undefined' && VastaShop.Product.current) {
                // Track product view event
                console.log('Product viewed:', VastaShop.Product.current.title);
            }
        }
        
        function initializeProductFeatures() {
            // Any additional product features can be initialized here
            // This could include things like:
            // - Product recommendations
            // - Size guides
            // - Product comparison
            // - etc.
        }
        
        function initializeReviewStarsClick() {
            // Handle clicks on review stars to open reviews tab
            $(document).on('click', '.js-reviews-trigger', function(e) {
                e.preventDefault();
                
                // Find the reviews tab trigger button
                const reviewsTabTrigger = document.querySelector('[data-tab="reviews"]');
                
                if (reviewsTabTrigger) {
                    // Trigger click on reviews tab
                    reviewsTabTrigger.click();
                    
                    // Scroll to the tabs section after a brief delay
                    setTimeout(function() {
                        const tabsSection = document.querySelector('.tabs-section');
                        if (tabsSection) {
                            tabsSection.scrollIntoView({ 
                                behavior: 'smooth', 
                                block: 'start' 
                            });
                        }
                    }, 100);
                    
                    // Track this interaction for analytics
                    console.log('Review stars clicked - opened reviews tab');
                    
                    // Dispatch custom event for analytics tracking
                    const reviewStarsClickEvent = new CustomEvent('reviewStarsClick', {
                        detail: { 
                            action: 'open_reviews_tab',
                            source: 'review_stars'
                        }
                    });
                    document.dispatchEvent(reviewStarsClickEvent);
                }
            });
        }
        
    });
    
})(jQuery); 